import moment from 'moment';

export default ({ date, children }) => {
  const momentDate = moment(date, 'DD/MM/YYYY HH:mm');
  if (moment().isAfter(momentDate)) {
    return null;
  }
  return children;
};
